var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callback",attrs:{"id":"callback","name":"callback"}},[_c('div',{staticClass:"callback-content"},[_c('div',{staticClass:"callback-text"},[_c('p',[_vm._v("正在登录中...")])])])])
}]

export { render, staticRenderFns }